/* eslint-disable @nx/enforce-module-boundaries */
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import {
  LoaderIndicatorDirective,
  LoaderService,
  NotificationService,
} from '@t-llevo/common-ui';
import {
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { UserService } from '../../../api/services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { finalize } from 'rxjs';
import { DialogHeaderComponent } from 'admin-drivers/src/app/common/dialog/components/dialog-header/dialog-header.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  emailValidators,
  passwordValidators,
} from 'admin-drivers/src/app/common/validators';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 't-llevo-user-add',
  standalone: true,
  imports: [
    LoaderIndicatorDirective,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    DialogHeaderComponent,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: './user-add.component.html',
  providers: [UserService, LoaderService],
  styles: `
  @import '../../../utils/styles/baseDialog.scss';
  @import '../../../utils/styles/formGroup.scss';
  `,
})
export class UserAddComponent {
  private userSrv = inject(UserService);
  private loaderSrv = inject(LoaderService);
  private notifSrv = inject(NotificationService);

  loading = toSignal(this.loaderSrv.loaderState$);
  protected passwordControlHide: boolean = true;

  @ViewChild('firstInput') elementRef!: ElementRef<HTMLInputElement>

  frm = this._fb.group({
    phone: ['', [Validators.required, Validators.pattern(/[0-9]{8}/)]],
    password: ['', passwordValidators],
    email: ['', emailValidators],
    firstname: ['', [Validators.required]],
    lastname: ['', [Validators.required]],
  });

  constructor(
    public dialogRef: MatDialogRef<UserAddComponent>,
    private _fb: NonNullableFormBuilder
  ) {
    this.dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => {
        this.elementRef.nativeElement.focus()
      }, 100)
    })
  }

  onSubmit() {
    this.frm.markAllAsTouched();

    if (this.frm.valid) {
      this.loaderSrv.show();

      const params = {
        ...this.frm.getRawValue(),
        roles: ['admin'],
      };

      this.userSrv
        .createUser(params)
        .pipe(
          finalize(() => {
            this.loaderSrv.hide();
          })
        )
        .subscribe({
          next: () => {
            this.notifSrv.dispatch('Usuario creado', 'success');
            this.dialogRef.close(true);
          },
          error: (err: HttpErrorResponse) => {
            this.notifSrv.dispatch(err.error.message, 'error');
          },
        });
    }
  }

  get phone() {
    return this.frm.controls['phone'];
  }

  get password() {
    return this.frm.controls['password'];
  }

  get email() {
    return this.frm.controls['email'];
  }

  get firstname() {
    return this.frm.controls['firstname']
  }

  get lastname() {
    return this.frm.controls['lastname']
  }
}
